import styles from './styles.scss';
import Button from 'Components/Button';
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import Typography from 'Components/Typography';

const cx = classNames.bind(styles);

const Congratulations = ({ nameBodyText, modalType, onClose, gaPush }) => {
  const headlineRef = useRef(null);

  useEffect(() => {
    headlineRef?.current.focus();
  }, []);

  return (
    <div className={cx(styles.container)}>
      <div
        className={cx(styles.congratsUpper)}
        style={{
          flexBasis:
            modalType.name !== 'NEWSLETTER' && window.hwsconfig.enableUsedCarEvaluation
              ? '60%'
              : '100%',
        }}
      >
        <div className={cx(styles.congratsUpperBlind)}>
          <div className={cx(styles.stackColumn)}>
            <div className={styles.heightSensitive}>
              <svg
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="59"
                height="59"
                viewBox="0 0 59 59"
                fill="none"
              >
                <circle cx="29.5" cy="29.5" r="28.5" stroke="white" strokeWidth="2" fill="none" />
                <path
                  d="M16.8569 30.0507L24.8573 40.0357L40.0355 21.0714"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <Typography.Headline
              ref={headlineRef}
              value={
                modalType.name === 'NEWSLETTER' ? 'Vielen Dank für Ihr Interesse!' : 'Gratulation!'
              }
              level="h2"
              forceUppercase={true}
              additionalProps={{
                id: 'modal-redesign-headline',
                'aria-live': 'assertive',
                role: 'alert',
                style: { marginTop: '30px' },
                tabIndex: '-1',
              }}
            />
            {modalType.name === 'TEST_DRIVE' && (
              <p>
                Schon bald erleben Sie den {nameBodyText} persönlich. Wir kontaktieren Sie zeitnah.
              </p>
            )}
            {modalType.name === 'REQUEST_FOR_PROPOSAL' && (
              <p>
                Wir haben Ihre Anfrage für einen {nameBodyText} erhalten. Wir kontaktieren Sie
                zeitnah.
              </p>
            )}
            {modalType.name === 'NEWSLETTER' && (
              <>
                <p>
                  Es freut uns, dass Sie mehr über den neuen {nameBodyText} erfahren möchten. Wir
                  lassen Ihnen in Kürze weitere Details zukommen.
                </p>
                <p>
                  Sollten Sie uns in der Vergangenheit noch keine Kontakterlaubnis erteilt haben,
                  senden wir Ihnen an Ihre E-Mail-Adresse umgehend eine Nachricht zur Bestätigung.
                  Bitte verifizieren Sie in diesem Fall Ihre E-Mail-Adresse, sodass wir Ihnen
                  zukünftig unseren Newsletter zukommen lassen können.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      {modalType.name !== 'NEWSLETTER' && window.hwsconfig.enableUsedCarEvaluation && (
        <div className={cx(styles.congratsLower)}>
          <div className={cx(styles.stackColumn)}>
            <h3 className={styles.headline3}>Gebrauchtwagenbewertung</h3>
            <div>
              Möchten Sie Ihr aktuelles Fahrzeug in Zahlung geben? Prüfen Sie jetzt den Wert Ihres
              Gebrauchtwagens!
            </div>
            <div>
              Hier gelangen Sie zur Gebrauchtwagenbewertung von mazda.de. Die
              Gebrauchtwagenbewertung von mazda.de wird technisch direkt auf der Händlerwebseite
              dargestellt. Hierbei erteilte Zustimmungen für den Einsatz von Cookies und ähnlichen
              Technologien gelten entsprechend.
            </div>
            <Button
              type="secondary"
              href="/gebrauchtwagenbewertung/"
              label="Zur Bewertung"
              onClick={() => {
                gaPush({
                  event: 'cta_interaction',
                  click_type: 'form cta',
                  click_value: 'Trade In',
                  category: 'CTA',
                });
                onClose();
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export { Congratulations };
